import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("perx_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    // Attach current country as a query param on every request so backend
    // filters (deals, product groups, offers) always know which market to
    // serve. Callers can override by passing `country` in their own params.
    const country = localStorage.getItem("perx_country");
    if (country) {
        config.params = { country, ...(config.params || {}) };
    }
    return config;
});

export function formatApiError(err) {
    const detail = err?.response?.data?.detail;
    if (!detail) return err?.message || "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}

export default api;
